/* ============================================================
   TCG Sound — efectos de sonido opcionales (sin archivos, WebAudio).
   Apagado por defecto. Toggle con [data-sound-toggle] (persiste en
   localStorage 'tcgSound'). Uso: window.tcgSound.play('win'|'ding'|'flip').
   
   FIX QA-017: Los navegadores bloquean audio hasta la primera interacción.
   Ahora el AudioContext se resume automáticamente en el primer click.
   ============================================================ */
window.tcgSound = (function () {
  'use strict';
  var KEY = 'tcgSound';
  var ctx = null;
  var on = false;
  try { on = localStorage.getItem(KEY) === 'on'; } catch (e) {}

  function ensure() {
    if (!ctx) {
      try { ctx = new (window.AudioContext || window.webkitAudioContext)(); } catch (e) { ctx = null; }
    }
    if (ctx && ctx.state === 'suspended') {
      try { ctx.resume().catch(function(){}); } catch (e) {}
    }
    return ctx;
  }

  function tone(freq, dur, type, delay, vol) {
    if (!ctx) return;
    var t0 = ctx.currentTime + (delay || 0);
    var osc = ctx.createOscillator();
    var g = ctx.createGain();
    osc.type = type || 'sine';
    osc.frequency.value = freq;
    g.gain.setValueAtTime(0, t0);
    g.gain.linearRampToValueAtTime(vol || 0.1, t0 + 0.01);
    g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
    osc.connect(g); g.connect(ctx.destination);
    osc.start(t0); osc.stop(t0 + dur + 0.02);
  }

  function play(name) {
    if (!on) return;
    if (!ensure()) return;
    // Reanudar si está suspendido (política de autoplay del navegador)
    if (ctx && ctx.state === 'suspended') {
      try { ctx.resume().catch(function(){}); } catch (e) {}
    }
    if (name === 'win') {
      [523.25, 659.25, 783.99, 1046.5].forEach(function (f, i) { tone(f, 0.22, 'triangle', i * 0.09, 0.12); });
    } else if (name === 'ding') {
      tone(880, 0.14, 'sine', 0, 0.14); tone(1318.5, 0.16, 'sine', 0.07, 0.1);
    } else if (name === 'flip') {
      tone(320, 0.07, 'square', 0, 0.06); tone(180, 0.09, 'square', 0.04, 0.05);
    }
  }

  /* Solo se toca el texto: si el boton trae icono propio (SVG), se conserva.
     Antes se reescribia todo el boton con un emoji de altavoz, que ademas
     borraba el icono del tema en cada cambio de estado. */
  function label(b) {
    var txt = on ? 'Sonido: ON' : 'Sonido: OFF';
    var slot = b.querySelector('[data-sound-label]');
    if (slot) slot.textContent = txt; else b.textContent = txt;
    b.setAttribute('aria-pressed', on);
    b.classList.toggle('is-sound-on', on);
  }

  function set(v) {
    on = v;
    try { localStorage.setItem(KEY, v ? 'on' : 'off'); } catch (e) {}
    document.querySelectorAll('[data-sound-toggle]').forEach(label);
    if (v) { ensure(); play('ding'); }
  }

  // FIX: Reanudar AudioContext en el primer click (política de autoplay)
  var firstClick = true;
  document.addEventListener('click', function() {
    if (firstClick) {
      firstClick = false;
      ensure();
    }
  }, { once: true });

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sound-toggle]');
    if (b) { e.preventDefault(); set(!on); }
  });
  function init() { document.querySelectorAll('[data-sound-toggle]').forEach(label); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  return { play: play, isOn: function () { return on; } };
})();

